import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { postBackgroundTypes } from '@gik/stream/utils/StreamPostUtils';
import { Button } from '@gik/ui/Button';
import { ColorSwatch } from '@gik/ui/ColorSwatch/ColorSwatch';
import React from 'react';

export type StreamPostBackgroundPickerProps = {
  open?: boolean;
  value?: string;
  onOpenChange?(value: boolean): void;
  onSelect?(colorName: string): void;
} & UIComponent;

function StreamPostBackgroundPickerComp({
  children,
  className,
  value = 'white',
  open,
  onOpenChange,
  onSelect,
  ...otherProps
}: React.PropsWithChildren<StreamPostBackgroundPickerProps>): React.ReactElement {
  const bem = useBemCN('stream-post-background-picker');

  const [_value, _setValue] = React.useState<string>(value);

  function handleSelect(colorName: string) {
    _setValue(colorName);
    onSelect(colorName);
  }

  return (
    <div {...bem(null, [{ open }], className)} {...otherProps}>
      <Button
        circle
        {...bem('btn-toggle', null, ['gik-stream-background-picker-button'])}
        uppercase={false}
        onClick={() => onOpenChange(!open)}
      >
        Aa
      </Button>
      <div {...bem('bg-picker')}>
        {postBackgroundTypes.map(colorName => {
          return (
            <ColorSwatch
              key={colorName}
              className={colorName}
              onClick={() => handleSelect(colorName)}
              active={colorName === _value}
            />
          );
        })}
      </div>
    </div>
  );
}

export const StreamPostBackgroundPicker = withComponentErrorBoundary(StreamPostBackgroundPickerComp);
